<template lang="pug">
div
  app-modal-visualizar-completo(
    v-if="showModalVisualizarProcesso && idProcesso !== null",
    @closeModal="showModalVisualizarProcesso = false",
    :idProcesso="idProcesso",
    :protocolo="protocolo",
    :numeroProcesso="numeroProcessoModal",
    :tipo="tipoProcesso"
  )
  el-card.card-container(shadow="hover")
    filtro(
      @pesquisar="pesquisarInformacoes",
      @limpar="clearInformacoes",
      :showOs="true",
      :configuracaoFiltro="configuracaoFiltro",
      :showfiltrosInformacoes="true",
      :placeholder="'Informe o nome do responsável ou tipo de processo'"
      :showFiltroTipoMultiplo="showFiltroTipoMultiplo"
    )
  app-listagem(
    caixa='INFORMACAO_SOLICITADA'
    :has-refresh-button="true",
    :showButtonOrdemServico="false",
    :showButtonAssinatura="false",
    :has-expansivel="false",
    :json-headers="colunas",
    :json-data="items",
    :totalElements="totalElements",
    :infoPrazos="showInfoVencimento() && infoPrazos"
    :pagina="filtro.pagina",
    @updateListagem="refreshInformacoes",
    @changePage="changePage",
    @sort="sort",
    @executar="executar",
    @selected="false"
  )
</template>

<script>
import AppListagem from '@/components/AppListagem'
import { mapActions } from 'vuex'
import Filtro from '@/screens/analise/listagem/Filtro'
import FILTRO_EMPTY from '@/models/filtro'
import AppModalVisualizarCompleto from '@/screens/analise/components/modal/AppModalVisualizarCompleto'
const { filtro, showFiltroTipoMultiplo } = require('@/utils/' + process.env.ESTADO + '/regrasAnalise').default
const BaseFiltro = require('@/screens/analise/listagem/' + process.env.ESTADO + '/BaseFiltro').default
const { setoresFormatado } = require('@/utils/' + process.env.ESTADO + '/setor').default

export default {

  beforeRouteLeave (to, from, next) {
    next()
  },

  components: {
    AppListagem,
    Filtro,
    AppModalVisualizarCompleto
  },

  mixins: [
    BaseFiltro
  ],

  data () {
    return {
      filtro: FILTRO_EMPTY('INFORMACAO_SOLICITADA'),
      items: [],
      setoresInfoVencimento: [ 'GAC', 'CAF', 'GPA', 'GCQ', 'GEO', 'GCG', 'CGIR', 'DEAF', 'GDA', 'GP', 'GRF', 'GAM', 'GEA', 'COF', 'DJ', 'CDI', 'GIT',
        'PROTOCOLO', 'COMISSAO_ILHA', 'CAF', 'JURIDICO', 'DF1', 'DRF', 'DATGL', 'PRESIDENCIA', 'DUF', 'GRF_CAF',
        'GCG_CGIR'],
      protocolo: null,
      idProcesso: null,
      tipoProcesso: null,
      numeroProcessoModal: null,
      totalElements: 0,
      infoPrazos: undefined,
      usuario: null,
      showModalVisualizarProcesso: false,
      configuracaoFiltro: {
        filtroOrdemServico: filtro?.filtroOrdemServico?.INFORMACAO_SOLICITADA || [],
        filtroFuncao: filtro?.filtroFuncao?.INFORMACAO_SOLICITADA || []
      },
      showFiltroTipoMultiplo,
      colunas: [
        { id: 0, titulo: 'Processo', propriedade: 'numeroProcesso', ordem: 1, acoes: [], type: 'icone', icone: 'comment-alt' },
        { id: 1, titulo: 'Responsável', propriedade: 'responsavel', ordem: 2, acoes: [] },
        { id: 2, titulo: 'Setor de Origem', propriedade: 'setor', ordem: 3, formatter: this.formataSetor, acoes: [] },
        { id: 3, titulo: 'Data Chegada', propriedade: 'dataChegada', ordem: 4, acoes: [] },
        { id: 4, titulo: 'Tipo de Processo', propriedade: 'tipoProcesso', ordem: 5, acoes: [] },
        { id: 8, titulo: 'Município', propriedade: 'municipios', ordem: 3, acoes: [], exibir: () => true },
        { id: 5, titulo: 'Status', propriedade: 'status', ordem: 6, acoes: [] },
        { id: 6, titulo: 'Data de vencimento', propriedade: 'dataVencimento', ordem: 6, acoes: [], isPrazo: true, exibir: () => this.showInfoVencimento() },
        {
          id: 7, titulo: 'Ações', propriedade: 'tipo', ordem: 7, //eslint-disable-line
          acoes: [
            { id: 1, nome: 'Visualizar Processo', icone: 'fa-eye', codigo: 'VISUALIZAR_PROCESSO', ordem: 1, show: this.showVisualizarProcesso },
            { id: 2, nome: 'Responder Informações', icone: 'fa-edit', codigo: 'VISUALIZAR_RESPONDER_INFORMACOES', ordem: 2, show: this.showResponderInformacoes },
            { id: 3, nome: 'Visualizar Informações', icone: 'fa-eye', codigo: 'VISUALIZAR_RESPONDER_INFORMACOES', ordem: 3, show: this.showVisualizarInformacoes }
          ]
        }
      ]
    }
  },

  props: {
    tipo: {
      type: String,
      required: false // trocar para true, quando tiver a props
    },
    numeroProcesso: {
      type: String,
      required: false
    }
  },

  async created () {
    this.usuario = await this.getUsuario()

    if (this.numeroProcesso) {
      this.filtro.numeroProcesso = this.numeroProcesso
      await this.pesquisar(this.filtro)
      this.filtro.numeroProcesso = ''
    }
  },

  watch: {
    async '$route' (to, from) {
      this.initInformacoes()
    }
  },

  methods: {
    ...mapActions({
      getUsuario: 'auth/getUsuario'
    }),
    showColuna (coluna) {
      return this.configuracaoFiltro[coluna].find(perfil => perfil === this.usuario.perfilSelecionado.codigo) !== undefined
    },
    formataSetor (prop) {
      return setoresFormatado[prop.setor]
    },
    showInfoVencimento () {
      return !!this.setoresInfoVencimento.find(setor => setor === this.usuario?.perfilSelecionado?.setor?.codigo)
    },
    VISUALIZAR_PROCESSO (_this, { item }) {
      this.idProcesso = item.idProcesso
      this.numeroProcessoModal = item.numeroProcesso
      this.tipoProcesso = item.tipoCodigo
      this.protocolo = item.numeroProtocolo
      this.showModalVisualizarProcesso = true
    },
    VISUALIZAR_RESPONDER_INFORMACOES (_this, { item }) {
      const modulo = this.usuario.moduloSelecionado.codigo
      let rota = ''
      switch (modulo) {
        case 'ARRECADACAO':
          rota = 'gat/informacoes'
          break
        case 'FINANCEIRO':
          rota = 'cof/informacoes'
          break
        default:
          rota = 'informacoes'
      }
      this.$router.push({
        name: rota,
        params: {
          idSolicitacao: item.id
        }
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.card-container {
  margin: 20px;
  border-radius: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/CaixaInformacoesListagem.vue